import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import EuReadinessCardiology from "@/pages/EuReadinessCardiology";

export const Route = createFileRoute("/en/eu-readiness-cardiology")({
  head: () => buildRouteHead("/en/eu-readiness-cardiology"),
  component: EuReadinessCardiology,
});

